'use client';

import { useRouter } from 'next/navigation';
import React from 'react';

const GetStartedButton = ({ className = '' }) => {
  const router = useRouter();

  const handleClick = () => {
    router.push('/get-started?skip_landing_page=true');
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center bg-[#e7a641] text-[18px] hover:bg-[#e59821] text-black md:whitespace-nowrap py-3 px-20 rounded-full ${className}`}
    >
      <span className="w-full text-left md:text-center">TRY FOR FREE</span>
    </button>
  );
};

export default GetStartedButton;
